Oskari.bundle_manager.registerDynamic('admin', function() {return import(/* webpackChunkName: "chunk_admin" */ 'oskari-loader!oskari-frontend/packages/admin/bundle/admin/bundle.js');});
